<ng-container *transloco="let t">
  <div class="content-wrapper">
    <div class="content">
      <div class="page-header">
        @if (backlink) {
        <xt-portal-button
          class="back-button"
          color="none"
          width="small"
          [icon]="'keyboard_double_arrow_left'"
          [text]="t(backlink.title)"
          (clickEvent)="navigate()"
          [xTentionDummyCypress]="dataCy + '.backlink'"
        />
        }
        <h1>{{ t(title) }}</h1>

        @if (hasRepresentativeData) {
        <span>
          <span>{{ t('app.labels.representedBy') }}&nbsp;</span>
          <span class="patient-name">
            {{ representativeName }}
            <xt-portal-button
              buttonStyle="flat-icon"
              [icon]="'info'"
              [color]="'white'"
              (clickEvent)="isOpen = !isOpen"
              cdkOverlayOrigin
              [ariaLabel]="t('app.labels.representedBy')"
              [size]="'small'"
              #trigger="cdkOverlayOrigin"
            />
          </span>
          @if (hasMultipleRepresentatives) {
          <span> + {{ additionalRepresentativesCount }} weitere </span>
          }
        </span>
        }
      </div>

      @if(hasRepresentativeData) {
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOpen]="isOpen"
        [cdkConnectedOverlayOrigin]="trigger"
        (overlayOutsideClick)="isOpen = false"
      >
        <xt-patients-details-representation-popup
          [patientRepresentation]="firstRepresentative"
          (closeEvent)="isOpen = false"
        />
      </ng-template>
      } @if (tooltip) {
      <mat-icon
        class="tooltip"
        [matTooltip]="tooltip"
        matTooltipClass="xtention-tooltip"
        svgIcon="information-outline"
      />
      } @if (helpIcon) {
      <mat-icon
        class="tooltip add-info"
        [ngClass]="{ 'help-icon': helpIcon }"
        matTooltipClass="xtention-tooltip"
        [svgIcon]="'information'"
        role="button"
        tabindex="0"
        aria-hidden="false"
        [attr.aria-label]="t('app.sidemenu.support')"
        [xTentionDummyCypress]="dataCy + '.page-header.information'"
        (keydown.enter)="openInfoDialog()"
        (click)="openInfoDialog()"
      />
      }
    </div>
    <div class="actions">
      @if (hasAction) {
      <div class="action-button">
        @if (hasExtraAction) {
        <xt-portal-button
          [text]="extraActionText"
          [xTentionDummyTooltip]="actionTooltip"
          [xTentionDummyTooltipFixByClick]="true"
          [style]="'stroked'"
          class="extraAction"
          [color]="actionColor"
          [iconPosition]="actionIconPosition"
          [width]="width"
          [textAlign]="actionTextAlign"
          (clickEvent)="onClickHandler('extraAction')"
          [xTentionDummyCypress]="dataCy + 'page-header.action'"
        />
        } @if (!isDropdown) {
        <xt-portal-button
          [xTentionDummyTooltip]="actionTooltip"
          [xTentionDummyTooltipFixByClick]="true"
          [text]="actionText"
          [style]="actionStyle"
          [color]="actionColor"
          [icon]="actionIcon"
          [disabled]="isActionDisabled"
          [iconPosition]="actionIconPosition"
          [ariaLabel]="actionText"
          [width]="width"
          [textAlign]="actionTextAlign"
          (clickEvent)="onClickHandler($event)"
          [xTentionDummyCypress]="dataCy + 'page-header.action'"
        />
        } @else {
        <xt-ui-kit-dropdown-button
          [text]="actionText"
          [style]="actionStyle"
          [color]="actionColor"
          [icon]="actionIcon"
          [iconPosition]="actionIconPosition"
          [width]="width"
          [dropdownItems]="dropdownItems"
          [xTentionDummyCypress]="dataCy + 'page-header.dropdown'"
          (clickEvent)="onClickHandler($event)"
        />
        }
      </div>
      } @if (hasSupportButton) {
      <mat-icon
        svgIcon="support-icon"
        role="button"
        tabindex="0"
        [attr.aria-label]="t('app.sidemenu.support')"
        class="support-icon"
        [xTentionDummyCypress]="dataCy + 'page-header.support-icon'"
        (keydown.enter)="openInfoDialog(true)"
        (click)="openInfoDialog(true)"
      />
      }
    </div>
  </div>

  @if (additionalInfo) {
  <div class="additionalInfo">
    @for (row of additionalInfo.rows; track row) {
    <strong class="label"> {{ t(row.label) }}: </strong>
    <span class="text">{{ t(row.value) }} </span>
    <span class="separator"> | </span>
    }
  </div>
  } @if (additionalText) {
  <p
    class="additionalText"
    [innerHTML]="additionalText && t(additionalText)"
  ></p>
  }
</ng-container>
